exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._15q71xihi71osPqENpQ3SY {\n  display: flex;\n  overflow: hidden;\n  max-width: 100%;\n  position: relative;\n  background-color: #f4f5f7;\n}\n._2HiseL8VTRFSV_SMwBveCT {\n  background-color: #00875a;\n}\n._2GZ2TgsPS1jPqVmHguGjB1 {\n  color: #00875a;\n}\n", ""]);
// Exports
exports.locals = {
	"page": "_15q71xihi71osPqENpQ3SY",
	"backgroundColor": "_2HiseL8VTRFSV_SMwBveCT",
	"textColor": "_2GZ2TgsPS1jPqVmHguGjB1"
};